const GET_DETAIL_DIMENSION_BY_ID = 'GET_DETAIL_DIMENSION_BY_ID'
const GET_DETAIL_DIMENSION_BY_ID_SUCCESS = 'GET_DETAIL_DIMENSION_BY_ID_SUCCESS'

const PUT_DIMENSION = 'PUT_DIMENSION'
const PUT_DIMENSION_SUCCESS = 'PUT_DIMENSION_SUCCESS'

const POST_DIMENSION = 'POST_DIMENSION'
const POST_DIMENSION_SUCCESS = 'POST_DIMENSION_SUCCESS'

const GET_DIMENSION_PAGES = 'GET_DIMENSION_PAGES'
const GET_DIMENSION_PAGES_SUCCESS = 'GET_DIMENSION_PAGES_SUCCESS'

const GET_DIMENSION_LIST = 'GET_DIMENSION_LIST'
const GET_DIMENSION_LIST_SUCCESS = 'GET_DIMENSION_LIST_SUCCESS'

const GET_DIMENSION_LIST_CATEGORY = 'GET_DIMENSION_LIST_CATEGORY'
const GET_DIMENSION_LIST_CATEGORY_SUCCESS = 'GET_DIMENSION_LIST_CATEGORY_SUCCESS'


const GET_DIMENSION_FRAME_TYPE = 'GET_DIMENSION_FRAME_TYPE'
const GET_DIMENSION_FRAME_TYPE_SUCCESS = 'GET_DIMENSION_FRAME_TYPE_SUCCESS'

const DimensionType = {
  GET_DETAIL_DIMENSION_BY_ID,
  GET_DETAIL_DIMENSION_BY_ID_SUCCESS,

  PUT_DIMENSION,
  PUT_DIMENSION_SUCCESS,

  POST_DIMENSION,
  POST_DIMENSION_SUCCESS,

  GET_DIMENSION_PAGES,
  GET_DIMENSION_PAGES_SUCCESS,

  GET_DIMENSION_LIST,
  GET_DIMENSION_LIST_SUCCESS,

  GET_DIMENSION_LIST_CATEGORY,
  GET_DIMENSION_LIST_CATEGORY_SUCCESS,

  GET_DIMENSION_FRAME_TYPE,
  GET_DIMENSION_FRAME_TYPE_SUCCESS
}

export default DimensionType
